<template>
  <div id="Faq">
    <div class="banner">
      <img src="/static/images/faq/faq_bg.png" alt=""><div class="bannerText">
      <div class="title">{{$t("faq.bannerText")}}</div>
        <div class="titleSub">{{$t("faq.bannerDetail")}}</div>
      </div>
    </div>
    <div class="content">
        <div class="con">
          <div class="left">
           <ul>
             <li :class="index ==selectId?'active':''" v-for="(item,index) in list" :key="item.name" @click="clickList(index)">{{$t(item.name)}}</li>
           </ul>
          </div>
          <div class="right">
            <div class="que" v-if="selectId==0">
              <div v-for="item in queList1" :key="(item.title,item.detail)">
                <div class="queBox">
                  <div class="queTitle">{{$t(item.title)}}</div>
                  <div class="queDetail">{{$t(item.detail)}}</div>
                </div>
              </div>
            </div>
            <div class="que" v-if="selectId==1">
              <div v-for="item in queList2" :key="(item.title,item.detail)">
                <div class="queBox">
                  <div class="queTitle">{{$t(item.title)}}</div>
                  <div class="queDetail">{{$t(item.detail)}}</div>
                </div>
              </div>
            </div>
            <div class="que" v-if="selectId==2">
              <div v-for="(item,index) in queList3" :key="(item.title,item.detail,index)">
                <div class="queBox">
                  <div class="queTitle">{{$t(item.title)}}</div>
                  <div class="queDetail" v-if="index!==2">{{$t(item.detail)}}</div>
                  <div class="queDetail flexBox" v-if="index===2">
                    <div class="kfBox">
                      <div>{{$t(item.detail.name1)}}</div>
                      <div><img :src="item.detail.img1" alt=""></div>
                    </div>
                    <div class="kfBox">
                      <div>{{$t(item.detail.name2)}}</div>
                      <div><img :src="item.detail.img2" alt=""></div>
                    </div>
                    <div class="kfBox">
                      <div>{{$t(item.detail.name3)}}</div>
                      <div><img :src="item.detail.img3" alt=""></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list:[
        {
          name:'faq.listName1'
        },
        {
          name:'faq.listName2'
        },
        {
          name:'faq.listName3'
        }
      ],
      queList1:[
        {
          title:'faq.queList1.title1',
          detail:'faq.queList1.detail1'
        },
        {
          title:'faq.queList1.title2',
          detail:'faq.queList1.detail2'
        },
        {
          title:'faq.queList1.title3',
          detail:'faq.queList1.detail3'
        },
        {
          title:'faq.queList1.title4',
          detail:'faq.queList1.detail4'
        },
        {
          title:'faq.queList1.title5',
          detail:'faq.queList1.detail5'
        },
        {
          title:'faq.queList1.title6',
          detail:'faq.queList1.detail6'
        },
        {
          title:'faq.queList1.title7',
          detail:'faq.queList1.detail7'
        },
        {
          title:'faq.queList1.title8',
          detail:'faq.queList1.detail8'
        },
        {
          title:'faq.queList1.title9',
          detail:'faq.queList1.detail9'
        },
        {
          title:'faq.queList1.title10',
          detail:'faq.queList1.detail10'
        }
      ],
      queList2:[
        {
          title:'faq.queList2.title1',
          detail:'faq.queList2.detail1'
        },
        {
          title:'faq.queList2.title2',
          detail:'faq.queList2.detail2'
        },
        {
          title:'faq.queList2.title3',
          detail:'faq.queList2.detail3'
        },
        {
          title:'faq.queList2.title4',
          detail:'faq.queList2.detail4'
        }
      ],
       queList3:[
        {
          title:'faq.queList3.title1',
          detail:'faq.queList3.detail1'
        },
        {
          title:'faq.queList3.title2',
          detail:'faq.queList3.detail2'
        },
        {
          title:'faq.queList3.title3',
          detail:{
            name1:'nelsoftkefu001',
            img1:'/static/images/faq/img1.png',
            name2:'nelsoftkefu002',
            img2:'/static/images/faq/img2.png',
            name3:'nelsoftkefu003',
            img3:'/static/images/faq/img3.png',
          }
        },
        {
          title:'faq.queList3.title4',
          detail:'faq.queList3.detail4'
        }
      ],
      selectId:0
    };
  },
  //定义这个sweiper对象
  computed: {},
  created:function () {
    window.scroll(0, 0);
    this.$emit('menuHiddens');
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    if (this.$getCookie("langs") == "en") {
      this.lang_en = true;
    } else {
      this.lang_en = false;
    }
    this.show=true
  },
  methods: {
    clickList(id){
      this.selectId = id
    },
  }
};
</script>
<style scoped lang="less" type="text/less">
#Faq{
  margin-top: 65px;
  .banner{
    position: relative;
    img{
      width: 100%;
    }
    .bannerText{
      position:absolute;
      top: 40%;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      .title{
        font-size: 40px;
        font-weight: bold;
        position: relative;
        padding-right: 40px;
        &::before{
          content:'';
          display: inline-block;
          height: 38px;
          width: 3px;
          background: #e2e2e2;
          position: absolute;
          right: 0;
          bottom: 7px;
        }
      }
      .titleSub{
        padding-left: 30px;
        font-size: 20px;
        max-width: 600px;
      }
    }
  }
  .content{
    padding: 60px 0;
    min-height: 400px;
    .con{
      width: 60%;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      .left{
        width: 40%;
        ul{
          li{
            width: 60%;
            margin: 0 auto;
            padding: 15px;
            margin-top: 10px;
            color: #666;
            font-size: 18px;
            font-weight: bold;
            cursor: pointer;
            &.active{
              border-left: 5px solid #333;
              color: #333;
              background: #F4F4F4;

            }
          }
        }
      }
      .right{
        width: 60%;
        max-width: 860px;
        .que{
          .queBox{
            .queTitle{
              font-size: 22px;
              color: #333;
              font-weight: bold;
              padding-top: 15px;
            }
            .queDetail{
              font-size: 16px;
              color: #666;
              padding: 10px 0 15px 0;
              white-space: pre-line;
              line-height: 24px;
            }
            .flexBox{
              display: flex;
              justify-content: flex-start;
              align-items: flex-start;
              .kfBox{
                margin-right: 10px;
              }
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Faq/Faq.vue